__turbopack_context__.v({
  "active": "NavButtons-module__DP_7jq__active",
  "burgerMenu": "NavButtons-module__DP_7jq__burgerMenu",
  "counter": "NavButtons-module__DP_7jq__counter",
  "faves": "NavButtons-module__DP_7jq__faves",
  "heartDefault": "NavButtons-module__DP_7jq__heartDefault",
  "heartHover": "NavButtons-module__DP_7jq__heartHover",
  "horizontalNavOnly": "NavButtons-module__DP_7jq__horizontalNavOnly",
  "iconWrapper": "NavButtons-module__DP_7jq__iconWrapper",
  "item": "NavButtons-module__DP_7jq__item",
  "notHorizontalNav": "NavButtons-module__DP_7jq__notHorizontalNav",
  "searchBarWrapper": "NavButtons-module__DP_7jq__searchBarWrapper",
});
